import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#636363',
				secondary: '#b71c1c',
				accent: '#C1272D',
				info: '#5D4037',
				error: '#b71c1c',
			},
		},
	},
});
